'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDnd = require('react-dnd');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DragTypes = {
  ROW: 'row'
};
var rowSource = {
  beginDrag: function beginDrag(_ref) {
    var rowId = _ref.rowId;

    return { rowId: rowId };
  }
};
var rowTarget = {
  hover: function hover(targetProps, monitor) {
    var targetRowId = targetProps.rowId;
    var sourceProps = monitor.getItem();
    var sourceRowId = sourceProps.rowId;

    if (sourceRowId !== targetRowId) {
      targetProps.onMove({ sourceRowId: sourceRowId, targetRowId: targetRowId });
    }
  }
};

var dragSource = (0, _reactDnd.DragSource)( // eslint-disable-line new-cap
DragTypes.ROW, rowSource, function (connect) {
  return {
    connectDragSource: connect.dragSource()
  };
});
var dropTarget = (0, _reactDnd.DropTarget)( // eslint-disable-line new-cap
DragTypes.ROW, rowTarget, function (connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
});
var row = function row(_ref2) {
  var connectDragSource = _ref2.connectDragSource;
  var connectDropTarget = _ref2.connectDropTarget;
  var children = _ref2.children;
  var onMove = _ref2.onMove;
  var rowId = _ref2.rowId;

  var props = _objectWithoutProperties(_ref2, ['connectDragSource', 'connectDropTarget', 'children', 'onMove', 'rowId']);

  return (
    // If you want to drag using a handle instead, then you need to pass
    // connectDragSource to a customized cell (DndCell) through React
    // context and wrap the handle there. You also need to annotate
    // this function using connectDragPreview.
    connectDragSource(connectDropTarget(_react2.default.createElement(
      'tr',
      props,
      children
    )))
  );
};

exports.default = dragSource(dropTarget(row));


//////////////////
// WEBPACK FOOTER
// ./~/reactabular-dnd/dist/row.js
// module id = 1383
// module chunks = 0